import {Component, ViewChild, Input, Output, EventEmitter, ElementRef, SimpleChanges} from '@angular/core';
import {ClientContactsModel} from "../../../models/client-contacts/client-contacts.model";
import {ClientContactsType} from "../../../models/client-contacts/client-contacts.type";
import {Http} from "@angular/http";
import {ToasterService} from "angular2-toaster";
import {ActivatedRoute} from "@angular/router";
import {ApplicationUser} from "../../../services/ApplicationUser";
import {ClientsService} from "../../../models/clients/clients.service";
import {ClientVolumesService} from "../../../models/client-volumes/client-volumes.service";
import {ClientContactsService} from "../../../models/client-contacts/client-contacts.service";
import {ClientOwnersService} from "../../../models/client-owners/client-owners.service";
import {ClientBanksService} from "../../../models/client-banks/client-banks.service";
import {ClientProcessorsService} from "../../../models/client-processors/client-processors.service";
import {StaticDataService} from "../../../services/StaticData.service";

import * as _ from "lodash";
import * as moment from "moment/moment";

import {Observable} from 'rxjs/Observable';
import {IClientModel} from "../../../models/clients/clients.model";
import {ClientLocationsModel} from "../../../models/client-locations/client-locations.model";
import {ValidationService} from "../../../services/validation.service";

import {phoneFormatter} from "../../../helpers/phone-format";

declare var $: JQueryStatic | any;


@Component({
    selector: 'contacts',
    templateUrl: 'contacts.template.html',
    styleUrls: ['style.css'],
    exportAs: 'contacts'
})
export class ContactsComponent {
    @Input('client')
    @Output('client')
    public client;

    phoneFormatter = phoneFormatter;

    @Input('clientId')
    public clientId: number;

    @Input('editMode')
    public editMode = false;

    @Input('clientContacts')
    @Output('clientContacts')
    public clientContacts = {
        emergency: <ClientContactsModel> {type: ClientContactsType.EMERGENCY},
        landlord: <ClientContactsModel> {type: ClientContactsType.FRANCHISOR},
        key_supplier: <ClientContactsModel> {type: ClientContactsType.KEY_SUPPLIER},
        franchisor: <ClientContactsModel> {type: ClientContactsType.LANDLORD},
        emergency2: <ClientContactsModel> {type: ClientContactsType.EMERGENCY2},
    };

    public loadingCount: any = 100000;

    public $contactsForm: any;

    constructor(
        private http: Http,
        private toasterService: ToasterService,
        private route: ActivatedRoute,
        public profile: ApplicationUser,
        public clientContactsService: ClientContactsService,
        protected validationService: ValidationService,
        protected el: ElementRef
    ) {

    }

    public isLoaded() {
        return this.loadingCount < 0.1;
    }


    ngOnInit() {
        this.loadingCount = 1;
        if (this.clientId) {
            this.clientContactsService.getListByClient(this.clientId)
                .subscribe((res) => {
                    let contacts = res.data;

                    this.clientContacts.emergency = _.find(contacts, {type: ClientContactsType.EMERGENCY}) || <ClientContactsModel> {type: ClientContactsType.EMERGENCY};
                    this.clientContacts.franchisor = _.find(contacts, {type: ClientContactsType.FRANCHISOR}) || <ClientContactsModel> {type: ClientContactsType.FRANCHISOR};
                    this.clientContacts.key_supplier = _.find(contacts, {type: ClientContactsType.KEY_SUPPLIER}) || <ClientContactsModel> {type: ClientContactsType.KEY_SUPPLIER};
                    this.clientContacts.landlord = _.find(contacts, {type: ClientContactsType.LANDLORD}) || <ClientContactsModel> {type: ClientContactsType.LANDLORD};
                    this.clientContacts.emergency2 = _.find(contacts, {type: ClientContactsType.EMERGENCY2}) || <ClientContactsModel> {type: ClientContactsType.EMERGENCY2};

                    this.loadingCount--;
                }, (error) => {
                    try {
                        let errorData = JSON.parse(error._body);
                        if (errorData.code / 1000 < 4.99) this.loadingCount--;
                    } catch (ee) {}
                });
        }
    }


    ngAfterViewInit() {
        this.$contactsForm = $('[name="contacts-form"]', this.el.nativeElement);

        this.validateForm();
    }

    ngOnChanges(changes: any) {
        if (changes.clientId) this.ngOnInit();
    }


    // ===========================================================
    // Actions
    // ===========================================================

    public validate() {
        return this.$contactsForm.valid();
    }

    public save() {
        this.$contactsForm.submit();
    }


    // ===========================================================
    // Functions
    // ===========================================================


    validateForm() {

        this.$contactsForm
            .validate({
                submitHandler: (form) => {
                    this.loadingCount++;
                    this.clientContactsService.saveList(this.clientId, _.toArray(this.clientContacts))
                        .subscribe(
                            (res) => {
                                let contacts = res.data;

                                this.clientContacts.emergency = _.find(contacts, {type: ClientContactsType.EMERGENCY});
                                this.clientContacts.franchisor = _.find(contacts, {type: ClientContactsType.FRANCHISOR});
                                this.clientContacts.key_supplier = _.find(contacts, {type: ClientContactsType.KEY_SUPPLIER});
                                this.clientContacts.landlord = _.find(contacts, {type: ClientContactsType.LANDLORD});
                                this.clientContacts.emergency2 = _.find(contacts, {type: ClientContactsType.EMERGENCY2});

                                this.loadingCount--;
                            },
                            (error) => {
                                this.validationService.showError(error, form);
                            });

                }
            });

    }

}



// WEBPACK FOOTER //
// ./src/app/modules/client-forms/contacts/contacts.component.ts